var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-table',{attrs:{"xpage":"(p) => {page = p;loadZones();}","xsearch":"(q) => { query = q; loadZones(); }","items":_vm.tableConfig.items.value,"xpages":"pages","xxpage":"page","fields":_vm.tableConfig.fields,"actions":_vm.tableConfig.actions,"xpaging":"","loading":_vm.loading,"data-cy":"zones-table","search-data-cy":"zone-search"},on:{"clickItem":_vm.tableConfig.clickItemCallback},scopedSlots:_vm._u([(!_vm.hideCreate)?{key:"actions",fn:function(){return [_c('v-btn',{staticClass:"text-h4",attrs:{"rounded":"","color":"secondary","depressed":"","to":{ name: 'zone', params: { zoneId: 'new' } },"disabled":!_vm.$can('create', 'Zone'),"data-cy":"create-zone"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-plus-circle-outline")]),_vm._v(" Create zone ")],1)]},proxy:true}:null,{key:"value-createdAt",fn:function(ref){
var item = ref.item;
var value = ref.value;
var field = ref.field;
return [_vm._v(" "+_vm._s(_vm._f("moment")(value,"from"))+" ")]}},{key:"value-floor",fn:function(ref){
var item = ref.item;
var value = ref.value;
var field = ref.field;
return [_vm._v(" "+_vm._s(value.name)+" ")]}},{key:"value-updatedAt",fn:function(ref){
var item = ref.item;
var value = ref.value;
var field = ref.field;
return [_vm._v(" "+_vm._s(_vm._f("moment")(value,"from"))+" ")]}},{key:"value-zones",fn:function(ref){
var item = ref.item;
var value = ref.value;
var field = ref.field;
return [_vm._v(" "+_vm._s(value ? value.length : 0)+" ")]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }